import { createListFilters } from 'app/components'

export type LogsConsultaFilters = {
  paciente: string
  protocolo: string
  responsavel: string
  /** Solicitação a partir desta data (aaaa-mm-dd). */
  solicitacao: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<LogsConsultaFilters>({
  paciente: '',
  protocolo: '',
  responsavel: '',
  solicitacao: '',
})
